import { PropTypes } from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence } from "framer-motion";

import NewUserForm from "./NewUserForm";

LoginModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  userEmail: PropTypes.string,
};

export default function LoginModal({ show, setShow, userEmail }) {
  const close = () => {
    window.data.loginLevel = "full";
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <Wrapper>
          <NewUserForm
            handleCloseClick={close}
            onFormComplete={close}
            headerText="Great! Let's get you fully logged in:"
            defaultContactInfo={userEmail}
          />
        </Wrapper>
      )}
    </AnimatePresence>
  );
}

const Wrapper = styled.div`
  margin: 0 15px 10px;
`;
